// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createContext } from 'react';
import { useStickyPosition } from '../internal/components/sticky-header/use-sticky-position';
export const StickyHeaderContext = createContext({
    isStuck: false,
    isStuckAtBottom: false,
});
export const useStickyHeader = (rootRef, headerRef, __stickyHeader, __stickyOffset, __mobileStickyOffset, __disableMobile, __additionalOffset = false) => useStickyPosition(rootRef, headerRef, {
    sticky: __stickyHeader,
    offset: __stickyOffset,
    mobileOffset: __mobileStickyOffset,
    disableMobile: __disableMobile,
    additionalOffset: __additionalOffset,
});
//# sourceMappingURL=use-sticky-header.js.map